var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecureDocUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 66,
    viewBox: "0 0 87 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-20",
    strokeWidth: 1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: -4,
    width: 69,
    height: 62
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(&quot",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_277_14)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1 50C8.4225 50 6.98697 49.3885 5.7934 48.1656C4.59983 46.9427 4.00203 45.4708 4 43.75V6.25C4 4.53125 4.5978 3.06042 5.7934 1.8375C6.989 0.614583 8.42453 0.00208333 10.1 0H28.1893C28.324 0 28.4531 0.0543597 28.5471 0.150767L34.3528 6.09923C34.4469 6.19564 34.576 6.25 34.7107 6.25H58.9C60.5775 6.25 62.014 6.8625 63.2096 8.0875C64.4052 9.3125 65.002 10.7833 65 12.5V43.75C65 45.4687 64.4032 46.9406 63.2096 48.1656C62.0161 49.3906 60.5795 50.0021 58.9 50H10.1Z",
    fill: "url(#paint0_linear_277_14)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 11.5051,
    y: 8,
    width: 74.896,
    height: 58
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(&quot",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_277_14)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1076 13.5565C25.3146 12.646 26.1241 12 27.0578 12H80.4001C81.7132 12 82.67 13.2438 82.3333 14.5129L71.1894 56.5129C70.9568 57.3896 70.1634 58 69.2563 58H17.5059C16.2224 58 15.2711 56.8081 15.5557 55.5565L25.1076 13.5565Z",
    fill: "url(#paint1_linear_277_14)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0576 12.5H80.4004C81.385 12.5002 82.1021 13.433 81.8496 14.3848L70.7061 56.3848C70.5316 57.0422 69.9361 57.5 69.2559 57.5H17.5059C16.5432 57.5 15.8295 56.6057 16.043 55.667L25.5947 13.667C25.7501 12.9843 26.3575 12.5001 27.0576 12.5Z",
    stroke: "url(#paint2_linear_277_14)",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 33.9045,
    y: 19.5,
    width: 31.1909,
    height: 28.75
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.5px)",
      clipPath: "url(&quot",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_277_14)",
    "data-figma-bg-blur-radius": 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.067 25.75C49.2594 25.4167 49.7406 25.4167 49.933 25.75L59.0263 41.5C59.2187 41.8333 58.9782 42.25 58.5933 42.25H40.4067C40.0218 42.25 39.7813 41.8333 39.9737 41.5L49.067 25.75Z",
    fill: "url(#paint3_linear_277_14)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6338 25.5C49.0187 24.8333 49.9813 24.8333 50.3662 25.5L59.459 41.25C59.8438 41.9165 59.3633 42.7497 58.5938 42.75H40.4062C39.6367 42.7497 39.1562 41.9165 39.541 41.25L48.6338 25.5Z",
    stroke: "url(#paint4_linear_277_14)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_277_14",
    x: 0,
    y: -4,
    width: 69,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_277_14"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_277_14",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_277_14_clip_path",
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1 50C8.4225 50 6.98697 49.3885 5.7934 48.1656C4.59983 46.9427 4.00203 45.4708 4 43.75V6.25C4 4.53125 4.5978 3.06042 5.7934 1.8375C6.989 0.614583 8.42453 0.00208333 10.1 0H28.1893C28.324 0 28.4531 0.0543597 28.5471 0.150767L34.3528 6.09923C34.4469 6.19564 34.576 6.25 34.7107 6.25H58.9C60.5775 6.25 62.014 6.8625 63.2096 8.0875C64.4052 9.3125 65.002 10.7833 65 12.5V43.75C65 45.4687 64.4032 46.9406 63.2096 48.1656C62.0161 49.3906 60.5795 50.0021 58.9 50H10.1Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_277_14",
    x: 11.5051,
    y: 8,
    width: 74.896,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_277_14"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_277_14",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_277_14_clip_path",
    transform: "translate(-11.5051 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1076 13.5565C25.3146 12.646 26.1241 12 27.0578 12H80.4001C81.7132 12 82.67 13.2438 82.3333 14.5129L71.1894 56.5129C70.9568 57.3896 70.1634 58 69.2563 58H17.5059C16.2224 58 15.2711 56.8081 15.5557 55.5565L25.1076 13.5565Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_277_14",
    x: 33.9045,
    y: 19.5,
    width: 31.1909,
    height: 28.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_277_14"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_277_14",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_277_14_clip_path",
    transform: "translate(-33.9045 -19.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.067 25.75C49.2594 25.4167 49.7406 25.4167 49.933 25.75L59.0263 41.5C59.2187 41.8333 58.9782 42.25 58.5933 42.25H40.4067C40.0218 42.25 39.7813 41.8333 39.9737 41.5L49.067 25.75Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_277_14",
    x1: 34.5,
    y1: 0,
    x2: 34.5,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#165CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0732B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_277_14",
    x1: 4.8,
    y1: 62.6,
    x2: 54.7265,
    y2: -7.99554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_277_14",
    x1: 76.2,
    y1: 62.6,
    x2: 40.1328,
    y2: -1.08389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_277_14",
    x1: 34.55,
    y1: 50.3,
    x2: 61,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_277_14",
    x1: 58.7,
    y1: 50.3,
    x2: 38,
    y2: 25.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureDocUploadIcon);
export default __webpack_public_path__ + "static/media/secure-doc-upload-icon.ed86e9610bfe08f033c8eb941471eb95.svg";
export { ForwardRef as ReactComponent };